module.exports = __webpack_public_path__ + "static/media/details-22-image-1.eae206fc.jpg";